export type ProjectStep =
  | 'get_started'
  | 'location'
  | 'primary_or_detached'
  | 'project_type'
  | 'has_existing_equipment';

export const PROJECT_PROGRESS_STEPS: ProjectStep[] = [
  'location',
  'primary_or_detached',
  'project_type'
];

export function projectProgressSteps(
  includeHasExistingEquipment: boolean
): ProjectStep[] {
  if (!includeHasExistingEquipment) {
    return PROJECT_PROGRESS_STEPS;
  }
  return [...PROJECT_PROGRESS_STEPS, 'has_existing_equipment'];
}
